/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createSharedDirectoryResponseFromDiscriminatorValue, type HttpValidationProblemDetails, type IError, type SharedDirectoryResponse } from '../../../models/index.js';
// @ts-ignore
import { FilesRequestBuilderNavigationMetadata, type FilesRequestBuilder } from './files/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /shares/directories/{token}
 */
export interface WithTokenItemRequestBuilder extends BaseRequestBuilder<WithTokenItemRequestBuilder> {
    /**
     * The files property
     */
    get files(): FilesRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SharedDirectoryResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<WithTokenItemRequestBuilderGetQueryParameters> | undefined) : Promise<SharedDirectoryResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithTokenItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface WithTokenItemRequestBuilderGetQueryParameters {
    directoryId?: Guid;
    directoryPage?: number;
    directoryPageSize?: number;
    filePage?: number;
    filePageSize?: number;
}
/**
 * Uri template for the request builder.
 */
export const WithTokenItemRequestBuilderUriTemplate = "{+baseurl}/shares/directories/{token}{?directoryId*,directoryPage*,directoryPageSize*,filePage*,filePageSize*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithTokenItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithTokenItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    files: {
        navigationMetadata: FilesRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithTokenItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithTokenItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSharedDirectoryResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
